export { getPageConfigsRuntime };
export { getAllPageIds };
import { parseGlobResults } from './getPageFiles/parseGlobResults.js';
import { getPageConfigUserFriendlyNew } from './page-configs/getPageConfigUserFriendly.js';
import { unique } from './utils.js';
function getPageConfigsRuntime(virtualFileExports) {
    const { pageFilesAll, pageConfigs, pageConfigGlobal } = parseGlobResults(virtualFileExports);
    const allPageIds = getAllPageIds(pageFilesAll, pageConfigs);
    // TODO/now: re-use this call, instead of calling it twice
    const globalConfig = getPageConfigUserFriendlyNew(pageConfigGlobal);
    // TODO/now DEDUPE
    const pageConfigsUserFriendly = Object.fromEntries(pageConfigs.map((pageConfig) => {
        const configValues = { ...pageConfigGlobal.configValues, ...pageConfig.configValues };
        const page = {
            ...getPageConfigUserFriendlyNew({ configValues }),
            route: pageConfig.routeFilesystem?.routeString ?? null
        };
        return [pageConfig.pageId, page];
    }));
    return { pageFilesAll, allPageIds, pageConfigs, pageConfigGlobal, globalConfig, pageConfigsUserFriendly };
}
function getAllPageIds(pageFilesAll, pageConfigs) {
    const fileIds = pageFilesAll.filter(({ isDefaultPageFile }) => !isDefaultPageFile).map(({ pageId }) => pageId);
    const allPageIds = unique(fileIds);
    const allPageIds2 = pageConfigs.map((p) => p.pageId);
    return [...allPageIds, ...allPageIds2];
}
